var def = require("./imports").default;
var THREE = def.THREE;
var Edge = def.Edge;
var Node = def.Node;
var d3 = def.d3;
var ee = def.ee;
var d3Scale = require("d3-scale");
var d3Chromatic = require("d3-scale-chromatic");

module.exports = function (self) {





  /**
   *  Change color of node edges
   */
  self.highlightNode = function (node, toggle, color = def.NODE_HIGHLIGHT) {
    // if (toggle) {
    //   node.renderData.draw_object.children[0].material.color.setHex(color);
    //   node.renderData.draw_object.children[0].visible = false;
    // } else {
    //   node.renderData.draw_object.children[0].material.color.set(
    //     node.renderData.hcolor
    //   );
    //   node.renderData.draw_object.children[0].visible = false;
    // }
  };

  /**
   *  Highlight edges from and to a node and hide others
   */
  self.highlightEdges = function (node, toggle) {
    console.log("highlightEdges");
    const froms = [];
    const tos = [];
    for (var i = 0; i < self.selection.length; i++) {
      for (var j = 0; j < self.selection[i].links.length; j++) {
        if (!self.selection[i]) continue;
        froms.push(self.selection[i].links[j].fromId);
        tos.push(self.selection[i].links[j].toId);
      }
    }
    if (toggle) {
      for (var i = 0; i < node.links.length; i++) {
        froms.push(node.links[i].fromId);
        tos.push(node.links[i].toId);
      }
      self.highlightNeighbors(node, froms, tos);
    } else {
      self.highlightNeighbors(node, froms, tos);
    }
  };

  /**
   *  Highlight edges and nodes on the path
   */
  self.highlightPathEdgeNode = function (pathnode) {
    if (pathnode.length == 0) {
      //no path selected
      self.graph.forEachNode(function (n) {
        self.colorNodeOpacity(n, 1);
      });
      self.highlightAllEdges();
      return;
    }
    //first dehighlight all nodes
    self.graph.forEachNode(function (n) {
      self.colorNodeOpacity(n, 0.2);
    });

    pathnode.forEach((node) => {
      self.colorNodeOpacity(node, 1);
    });
    self.highlightNode(pathnode[0], true);
    self.highlightNode(pathnode[pathnode.length - 1], true);
    // pathnode[0].renderData.draw_object.children[0].material.color.setHex(def.NODE_HIGHLIGHT);
    // pathnode[pathnode.length - 1].renderData.draw_object.children[0].material.color.setHex(def.NODE_HIGHLIGHT);

    //highlight edges
    let red = new THREE.Color(appState.graph.edges.color).r;
    let blue = new THREE.Color(appState.graph.edges.color).g;
    let green = new THREE.Color(appState.graph.edges.color).b;

    //first dehighlight all edges
    self.lineIndices.forEach(function (link) {
      link.linecolor.r = self.darkMode ? 0.25 : 0.89; //black/white
      link.linecolor.g = self.darkMode ? 0.25 : 0.89;
      link.linecolor.b = self.darkMode ? 0.25 : 0.89;
    });
    //undirected
    //then highlight only the node's edges
    // for (let i = 0; i < pathnode.length-1; i++) {
    //   self.lineIndices.forEach(function (link) {
    //     if ((link.source.id == pathnode[i].id && link.target.id == pathnode[i+1].id) || (link.source.id == pathnode[i+1].id && link.target.id == pathnode[i].id))  {
    //       link.linecolor.r = red;
    //       link.linecolor.g = blue;
    //       link.linecolor.b = green;
    //     }
    //   })
    // }
    const pathnnodeid = pathnode.map((p) => p.id);
    self.lineIndices.forEach(function (link) {
      if (
        (pathnnodeid.indexOf(link.source.id) !== -1 &&
          pathnnodeid.indexOf(link.target.id) !== -1) ||
        (pathnnodeid.indexOf(link.target.id) !== -1 &&
          pathnnodeid.indexOf(link.source.id) !== -1)
      ) {
        link.linecolor.r = self.colorByDistance ? link.linecolor.r : red;
        link.linecolor.g = self.colorByDistance ? link.linecolor.g : blue;
        link.linecolor.b = self.colorByDistance ? link.linecolor.b : green;
      }
    });
  };

  /**
   * Highlight adjacent nodes
   *
   * Also highlights edges.
   */
  self.highlightNeighbors = function (node, froms, tos) {
    self.graph.forEachNode((n) => {
      if (self.selection.indexOf(n) != -1 || n == node) {
        // If the node is selected or the node is the node to be highlighted
        self.colorNodeOpacity(n, 1);
        self.colorNodeEdge(n); //set the node.renderData.linecolor , i.e. color edges by nodes
        // for (var i = 0; n.linkObjs && i < n.linkObjs.length; i++) {
        //   n.linkObjs[i].linecolor = n.renderData.linecolor;
        // }
      } else if (
        self.doHighlightNeighbors &&
        (froms.indexOf(n.id) != -1 || tos.indexOf(n.id) != -1)
      ) {
        // If the node is not selected or highlighted and
        // if the node is present in either froms or tos arrays
        self.colorNodeOpacity(n, 1);
        // self.colorNodeEdge(n, false);
      } else if (
        !self.prevHighlights ||
        self.prevHighlights.indexOf(n.id) == -1
      ) {
        self.colorNodeOpacity(n, 0.2);
        // self.colorNodeEdge(n, false);
        self.highlightNode(n, false, def.ADJACENT_HIGHLIGHT);
      }
    });
  };

  /**
   *  Change color of node edges
   */
  //  self.colorNodeEdge = function(node, isHighlighted) {
  //   let red = new THREE.Color(appState.graph.edges.color).r;
  //   let blue = new THREE.Color(appState.graph.edges.color).g;
  //   let green = new THREE.Color(appState.graph.edges.color).b;
  //   if(isHighlighted) {
  //     node.renderData.linecolor.r = red;
  //     node.renderData.linecolor.g = blue;
  //     node.renderData.linecolor.b = green;
  //     self.arrow.material.color.setRGB(red, blue, green);
  //   } else {
  //     node.renderData.linecolor.r =  self.darkMode ? 0.25 : .75;
  //     node.renderData.linecolor.g = self.darkMode ? 0.25 : .75;
  //     node.renderData.linecolor.b = self.darkMode ? 0.25 : .75;
  //   }

  // };

  self.colorNodeArrayEdge = function (nodearray) {
    let red = new THREE.Color(appState.graph.edges.color).r;
    let blue = new THREE.Color(appState.graph.edges.color).g;
    let green = new THREE.Color(appState.graph.edges.color).b;
    if (nodearray.length < 1) {
      //highlight all the edges

      self.lineIndices.forEach(function (link) {
        link.linecolor.r = self.colorByDistance ? link.linecolor.r : red;
        link.linecolor.g = self.colorByDistance ? link.linecolor.g : blue;
        link.linecolor.b = self.colorByDistance ? link.linecolor.b : green;
      });
    } else {
      //only highlight neighbor edges of nodes in the array
      //first dehighlight all edges
      self.lineIndices.forEach(function (link) {
        link.linecolor.r = self.darkMode ? 0.25 : 0.89; //black/white
        link.linecolor.g = self.darkMode ? 0.25 : 0.89;
        link.linecolor.b = self.darkMode ? 0.25 : 0.89;
      });
      //then highlight neighbor edges of nodes in the array
      nodearray.forEach((node) => {
        self.lineIndices.forEach(function (link) {
          if (link.source.id == node.id || link.target.id == node.id) {
            link.linecolor.r = self.colorByDistance ? link.linecolor.r : red;
            link.linecolor.g = self.colorByDistance ? link.linecolor.g : blue;
            link.linecolor.b = self.colorByDistance ? link.linecolor.b : green;
          }
        });
      });
    }
  };

  self.decolorNodeEdge = function (node) {
    let red = new THREE.Color(appState.graph.edges.color).r;
    let blue = new THREE.Color(appState.graph.edges.color).g;
    let green = new THREE.Color(appState.graph.edges.color).b;
    if (!node) return;
    else {
      //dehighlight any edges linkto/from the node
      //first dehighlight all edges
      self.lineIndices.forEach(function (link) {
        if (link.source.id == node.id || link.target.id == node.id) {
          link.linecolor.r = self.darkMode ? 0.25 : 0.89; //black/white
          link.linecolor.g = self.darkMode ? 0.25 : 0.89;
          link.linecolor.b = self.darkMode ? 0.25 : 0.89;
        }
      });
    }
  };

  self.changeSingleNodeColorEdge = function (node) {
    let red = new THREE.Color(appState.graph.edges.color).r;
    let blue = new THREE.Color(appState.graph.edges.color).g;
    let green = new THREE.Color(appState.graph.edges.color).b;
    if (!node) return;
    else {
      //only highlight the node's edges
      // //first dehighlight all edges
      // self.lineIndices.forEach(function (link) {
      //   link.linecolor.r = self.darkMode ? 0.25 : 0.89; //black/white
      //   link.linecolor.g = self.darkMode ? 0.25 : 0.89;
      //   link.linecolor.b = self.darkMode ? 0.25 : 0.89;
      // })
      //don't dehilight only do highlight the node's edges
      self.lineIndices.forEach(function (link) {
        if (link.source.id == node.id || link.target.id == node.id) {
          link.linecolor.r = self.colorByDistance ? link.linecolor.r : red;
          link.linecolor.g = self.colorByDistance ? link.linecolor.g : blue;
          link.linecolor.b = self.colorByDistance ? link.linecolor.b : green;
        }
      });
    }
  };

  // highlight only the node's neighbor edges in the whole sociogram
  self.colorNodeEdge = function (node) {
    let red = new THREE.Color(appState.graph.edges.color).r;
    let blue = new THREE.Color(appState.graph.edges.color).g;
    let green = new THREE.Color(appState.graph.edges.color).b;
    if (!node) {
      //highlight all the edges

      self.lineIndices.forEach(function (link) {
        link.linecolor.r = self.colorByDistance ? link.linecolor.r : red;
        link.linecolor.g = self.colorByDistance ? link.linecolor.g : blue;
        link.linecolor.b = self.colorByDistance ? link.linecolor.b : green;
      });
    } else {
      //only highlight the node's edges
      //first dehighlight all edges
      self.lineIndices.forEach(function (link) {
        link.linecolor.r = self.darkMode ? 0.25 : 0.89; //black/white
        link.linecolor.g = self.darkMode ? 0.25 : 0.89;
        link.linecolor.b = self.darkMode ? 0.25 : 0.89;
      });
      //then highlight only the node's edges
      self.lineIndices.forEach(function (link) {
        if (link.source.id == node.id || link.target.id == node.id) {
          link.linecolor.r = self.colorByDistance ? link.linecolor.r : red;
          link.linecolor.g = self.colorByDistance ? link.linecolor.g : blue;
          link.linecolor.b = self.colorByDistance ? link.linecolor.b : green;
        }
      });
    }

    // if (isHighlighted) {
    //   self.lineIndices.forEach(function (link) {
    //     if (link.source.id == node.id || link.target.id == node.id) {
    //       link.linecolor.r = red;
    //       link.linecolor.g = blue;
    //       link.linecolor.b = green;
    //     } else {
    //       link.linecolor.r = self.darkMode ? 0.25 : 0.89;
    //       link.linecolor.g = self.darkMode ? 0.25 : 0.89;
    //       link.linecolor.b = self.darkMode ? 0.25 : 0.89;
    //     }

    //   })

    //   // node.renderData.linecolor.r = red;
    //   // node.renderData.linecolor.g = blue;
    //   // node.renderData.linecolor.b = green;
    //   self.arrow.material.color.setRGB(red, blue, green);

    // } else {
    //   self.lineIndices.forEach(function (link) {
    //     link.linecolor.r = self.darkMode ? 0.25 : 0.89;
    //     link.linecolor.g = self.darkMode ? 0.25 : 0.89;
    //     link.linecolor.b = self.darkMode ? 0.25 : 0.89;
    //   })

    // node.renderData.linecolor.r =  self.darkMode ? 0.25 : 0.89;
    // node.renderData.linecolor.g = self.darkMode ? 0.25 : 0.89;
    // node.renderData.linecolor.b = self.darkMode ? 0.25 : 0.89;
  };

  // };

  /**
   *  Change node opacity
   */
  self.colorNodeOpacity = function (node, op) {
    node.renderData.draw_object.material.opacity = op;
  };
  self.colorNode = function (node, op) {
    node.renderData.draw_object.material.color.setHex(op);
  };

  /**
   *  rest color of the edges to default edge color
   */
  self.resetEdgeColors = function () {
    const baseColor = new THREE.Color(appState.graph.edges.color);

    self.lineIndices.forEach((link) => {
      link.linecolor.r = baseColor.r;
      link.linecolor.g = baseColor.g;
      link.linecolor.b = baseColor.b;
    });

    if (self.arrow?.material?.color) {
      self.arrow.material.color.copy(baseColor);
    }

    console.log("All edge colors reset to default.");
  };

  self.applyEdgeColorByDistance = function () {

    // const allDists = self.lineIndices
    //   .map(e => e.edgeDist)
    //   .filter(d => d !== undefined && !isNaN(d));
    // const maxEdgeDist = allDists.length > 0 ? Math.max(...allDists) : 1
    let maxEdgeDist = 0
    self.lineIndices.forEach((link) => {
      maxEdgeDist = Math.max(maxEdgeDist, link.edgeDist)
    })

    const colorScale = d3Scale.scaleSequential(d3Chromatic.interpolateViridis)
      .domain([0, maxEdgeDist]);

    self.lineIndices.forEach((link) => {
      if (link.edgeDist !== undefined) {
        const color = new THREE.Color(colorScale(link.edgeDist));
        link.linecolor.copy(color);
      }
    });

    console.log("Applied edge color encoding by distance.");
  };



};
